import { Paper, Spinner, Title } from "@yoast/ui-library";
import classNames from "classnames";
import * as styles from "./InstallStyles.module.scss";
import { ConnectedSites } from "../Subscription/ConnectedSites";
import { IncludedPlugins } from "../Subscription/IncludedPlugins";
import React, { useContext } from "react";
import { SubscriptionDetailContext } from "../../context/SubscriptionDetailContext";

export const SubscriptionDownloadableSetup = ( { productName } ) => {
	const { subscription, request: { isLoading } } = useContext( SubscriptionDetailContext );

	if ( ! isLoading && ! subscription ) {
		return <></>;
	}

	return <div className={ styles.ySpacing }>
		<Title as="p" size="4">{ productName }</Title>
		{ isLoading && <Spinner /> }
		{ subscription && <Paper className={ classNames( styles.paper, styles.ySpacing ) }>
			<ConnectedSites />
			<IncludedPlugins />
		</Paper> }
	</div>;
};
